import { setDefaultOptions } from 'date-fns'
import { nl } from 'date-fns/locale'

import '@/misc/lang'
import '@/bootstrap'
import '@/vue'
import '@/general'

// Import our custom SCSS files
import '@/../sass/app.scss'
import '@/../sass/fonts/icons.scss'

if (
  (typeof APP_ENV === 'undefined' ? import.meta.env.VITE_APP_ENV : APP_ENV) === 'local' &&
  (typeof NODE_ENV === 'undefined' ? import.meta.env.VITE_NODE_ENV : NODE_ENV) !== 'production'
) {
  import.meta.glob([
    '../assets/images/**',
    '../assets/fonts/**',
  ])

  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  import.meta.hot
}

if (['production', 'develop'].includes(typeof APP_ENV === 'undefined' ? import.meta.env.VITE_APP_ENV : APP_ENV)) {
  import('@/includes/sentry')
}

if ((typeof NODE_ENV === 'undefined' ? import.meta.env.VITE_NODE_ENV : NODE_ENV) === 'production') {
  import('@/includes/workbox')
}

// Set the default options for date-fns
setDefaultOptions({
  locale: nl,
  weekStartsOn: 1,
})

import('gaaf/app.js')
import('@/includes/websockets')
import('@/includes/maintenance-notification')

import('gaaf/modules/datatables.module.js')

import('@/includes')
